import { render } from "./ListeRecensementPage.vue?vue&type=template&id=a93be98a&ts=true"
import script from "./ListeRecensementPage.vue?vue&type=script&lang=ts"
export * from "./ListeRecensementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__